import { render, staticRenderFns } from "./VideoSidebar.vue?vue&type=template&id=2c40031e"
import script from "./VideoSidebar.vue?vue&type=script&lang=js"
export * from "./VideoSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports